import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

 /** Error when invalid control is dirty or touched*/
 // Manejo de erores en el formulario , Tocado , ensuciado, invalido..
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState( control: FormControl | null, form: FormGroupDirective | NgForm | null  ): boolean {
      const isSubmitted = form && form.submitted;
      return !!( control && control.invalid &&  (control.dirty || control.touched || isSubmitted)  );
    }
}